module.exports = __webpack_public_path__ + "img/Skating_1413_4.661ba5c4.jpg";